import { IDayTimeAvailabilityDto, Weekday } from '../../../common/interfaces/common';
import { AutoRenewalType } from '../constants/packages';
import IntlService from 'services/intl/IntlService';
import messages from 'modules/services/messages/packages';

export function sortAvailabilities(
  availabilities: IDayTimeAvailabilityDto[],
): IDayTimeAvailabilityDto[] {
  const sortedAvailabilities: IDayTimeAvailabilityDto[] = [];

  Object.values(Weekday).forEach(weekDay => {
    const availability = availabilities.find(item => item.weekday === weekDay);

    if (availability) {
      sortedAvailabilities.push(availability);
    }
  });

  return sortedAvailabilities;
}

export const getAutoRenewalTypeTranslate = (type: AutoRenewalType) => {
  switch (type) {
    case AutoRenewalType.Initial:
      return IntlService.formatMessage(messages.initial);
    case AutoRenewalType.Oot:
      return IntlService.formatMessage(messages.outOfTerm);
    case AutoRenewalType.Renewal:
      return IntlService.formatMessage(messages.autorenewal);
    default:
      return '';
  }
};
